import { ISelectOption }    from '@typings/components';
import { EUserStatus }      from '@enums/common';
import { USER_STATUS_NAME } from '@utils/suggestions';

export const INTRANET_USER_STATUSES: ISelectOption[] = [
  { label: USER_STATUS_NAME[EUserStatus.Active],   value: EUserStatus.Active },
  { label: USER_STATUS_NAME[EUserStatus.Inactive], value: EUserStatus.Inactive },
];

export const INTRANET_USER_PERMANENT: ISelectOption[] = [
  { label: 'Permanently Active', value: 'permanentlyActive' },
];
